import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
	selector: 'app-email-input-with-chips',
	templateUrl: './email-input-with-chips.component.html',
	styleUrls: ['./email-input-with-chips.component.scss']
})
export class EmailInputWithChipsComponent implements OnInit, OnDestroy {
	@Input() public isTextMessagingEnabled: boolean;
	@Input() public label: string;
	@Input() public parentForm: UntypedFormGroup;
	@Input() public placeholder: string;
	public subscriptions: any[] = [];


	constructor(private _subscriptionService: SubscriptionService) {
	}

	add(event: MatChipInputEvent): void {
		if (event.input.value && this.parentForm.get('email').valid) {
			const emails = this.parentForm.get('emails').value;
			const index = emails.findIndex((e) => e.toLowerCase() === event.value.toLowerCase());
			// Only add unique emails
			if (index === -1) {
				emails.push(event.value);
				this.parentForm.get('emails').setValue(emails);
			}
			if (event.input) {
				this.parentForm.get('email').setValue('', {onlySelf: true});
			}
			this.parentForm.get('emails').setErrors(null);
			this.parentForm.markAsDirty();
		}
	}

	ngOnDestroy(): void {
		this._subscriptionService.unSubscribe(this.subscriptions);
	}

	ngOnInit(): void {
		this.subscriptions.push(this.parentForm.get('emails').valueChanges.subscribe(() => {
			if (this.parentForm?.get('emails')?.errors?.maxLength) {
				this.parentForm.get('email').disable();
			} else {
				this.parentForm.get('email').enable();
			}
		}));
	}

	remove(index): void {
		const emails = this.parentForm.get('emails').value;
		emails.splice(index, 1);
		this.parentForm.get('emails').setValue(emails);
		this.parentForm.markAsDirty();
	}

}
